import React from 'react';
import { Helmet } from 'react-helmet';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { SectionHeader } from '../../common/components';

const Cart = () => {
  return (
    <>
      <Helmet>
        <title>Tarjouskori - Haku</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Tarjouskori']}
          Title="Tarjouskori - Haku"
        />
        <Link to="/cart/details/123">Tarjouskori demo</Link>
      </Container>
    </>
  );
};

export default Cart;
